import { useNavigate } from 'react-router'

import { HTML_LINK_TARGET } from '../../constants/html'
import { WEBAPP_ROUTE_PREFIX } from '../../constants/route'
import { isMiddleMouseButton, preventDefault } from '../../utils/events'
import { isHtmlLinkTargetBlank } from '../../utils/html'

/**
 * React hook that provides handlers for left and middle mouse clicks,
 * allowing non-anchor elements to behave like links (open in same or new tab).
 */
export function useLinkLikeClick() {
  const navigate = useNavigate()

  function handleClick({
    event,
    link,
    outsideLink,
    state,
    target = HTML_LINK_TARGET.self,
  }) {
    const shouldOpenInNewTab =
      event?.ctrlKey ||
      event?.metaKey ||
      outsideLink ||
      isHtmlLinkTargetBlank(target)

    if (link.includes(WEBAPP_ROUTE_PREFIX) || shouldOpenInNewTab) {
      window.open(link, shouldOpenInNewTab ? HTML_LINK_TARGET.blank : target)
    } else {
      navigate(link, { state })
    }
  }

  /**
   * Handles middle mouse button clicks (button === 1) via `onMouseDown`.
   * This approach ensures consistent behavior across browsers (Windows, macOS, Linux),
   * since `auxclick` can fire inconsistently or after the main click event.
   * Used to open links in a new tab, mimicking native anchor behavior.
   */
  function handleMouseDown({
    event,
    link,
    outsideLink,
    target = HTML_LINK_TARGET.blank,
  }) {
    if (isMiddleMouseButton(event)) {
      preventDefault(event)

      handleClick({ link, outsideLink, target })
    }
  }

  return {
    handleClick,
    handleMouseDown,
  }
}
